import Popup from "../PureComponents/Popup";
import React from "react";

const RenderPopup = ({ verify, hide }) => {
  return <Popup verify={verify} hide={hide} />;
};

export default RenderPopup;
